import type { ComponentType } from 'react';
import * as Icons from 'lucide-react';

type LucideComponent = ComponentType<{ size?: number; className?: string; strokeWidth?: number }>;

/**
 * Convert a mockup icon name to the PascalCase export lucide-react uses.
 * The mockup writes kebab-case (`check-circle`, `more-horizontal`); a few
 * call sites also pass already-PascalCase names, so we tolerate both.
 */
function toPascal(name: string): string {
  if (/^[A-Z]/.test(name) && !name.includes('-')) return name;
  return name
    .split('-')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join('');
}

/**
 * Resolve a Lucide icon by its mockup name at runtime (same technique the
 * existing `MerchantSidebar` uses). Falls back to `Circle` for unknown names
 * so a typo degrades gracefully instead of crashing the tree.
 */
export function Icon({ name, size = 18 }: { name: string; size?: number }): JSX.Element {
  const registry = Icons as unknown as Record<string, LucideComponent>;
  const Cmp = registry[toPascal(name)] ?? Icons.Circle;
  return <Cmp size={size} />;
}
